import { Children, cloneElement, isValidElement } from 'react';
import {
  ArrowPathIcon,
  BeakerIcon,
  CheckIcon,
  PaperAirplaneIcon,
  PlusIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline';
import { PaperAirplaneIcon as SolidPaperAirplaneIcon } from '@heroicons/react/24/solid';
import { ArrowPathIcon as SmallArrowPathIcon } from '@heroicons/react/20/solid';

// Component identities remain stable when production builds minify function names.
const decorativeIcons = new Set([
  ArrowPathIcon,
  BeakerIcon,
  CheckIcon,
  PaperAirplaneIcon,
  PlusIcon,
  XMarkIcon,
  SolidPaperAirplaneIcon,
  SmallArrowPathIcon,
]);

const componentName = (type) =>
  typeof type === 'string' ? type : type?.displayName || type?.render?.name || type?.name || '';

const buttonText = (children) =>
  Children.toArray(children)
    .map((child) =>
      isValidElement(child)
        ? buttonText(child.props.children)
        : typeof child === 'string'
          ? child
          : ''
    )
    .join('')
    .trim();

const isButton = (element) =>
  isValidElement(element) && ['button', 'Button'].includes(componentName(element.type));

export function normalizeModalActions(children) {
  const nodes = Children.toArray(children)
    .map((child) => {
      if (!isValidElement(child)) return child;
      const name = componentName(child.type);
      if (decorativeIcons.has(child.type) || name === 'svg' || name.endsWith('Icon')) return null;
      const props = {};
      if (child.props.children !== undefined) {
        props.children = normalizeModalActions(child.props.children);
      }
      if (isButton(child) && buttonText(child.props.children)) {
        props.className = `${child.props.className || ''} modal-action-btn`;
      }
      return cloneElement(child, props);
    })
    .filter((child) => child !== null);

  if (nodes.length > 1 && nodes.every(isButton)) {
    const isCancel = (node) =>
      /^(batal|tutup|close|cancel|kembali)$/i.test(buttonText(node.props.children));
    return [...nodes.filter(isCancel), ...nodes.filter((node) => !isCancel(node))];
  }
  return nodes;
}
